<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col cols="12" class="d-flex justify-end">
        <ButtonComp @click="addItem" textButton="Crear DÉBITO AUTOMÁTICO" icon-but="fas fa-plus" normal-button />
      </v-col>
      <v-col cols="12">
        <ComundataTablecomp whitSearch :headers="DebitoautomaticoHeaders" :items="listItems" :search="search"
          item-key="id_pago_automatico" v-model="selectedItems" :loading="loading">
          <template v-slot>
            <v-autocomplete label="Año" v-model="filtro.id_anio" :items="lista_filtro_anios" item-value="id"
              item-text="nom_anolectivo" @change="changeFiltroAnio()" autocomplete="off" style="max-width:200px">
            </v-autocomplete>
          </template>
          <template v-slot:fecha_inicio="{ item }">{{ item.fecha_inicio | filtroFecha }}</template>
          <template v-slot:fecha_fin="{ item }">{{ item.fecha_fin | filtroFecha }}</template>
          <template v-slot:estado="{ item }">
            <v-btn class="btn_block_style2" v-bind:class="item.estado == 'VIGENTE' ? 'btn_block_green' : 'btn_block_red'"
              x-small @click="return false;">
              {{ item.estado }}
            </v-btn>
          </template>

          <template v-slot:action_editar="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" verButton
              tooltip-text="Ver debito" />
          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>


    <!-- Modal -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="showDialog" max-width="900px" :title="formTitle" @close-modal="showDialog = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" md="6" sm="6" class="py-3">
              <v-autocomplete label="Nivel" v-model="editedItem.id_nivel" :items="lista_niveles" item-value="id"
                item-text="desc_nivel" @change="changeNivel()" autocomplete="off" :rules="[rul.selectReq]">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" sm="6" class="py-3">
              <v-autocomplete label="Grado" v-model="editedItem.id_grado" :items="lista_grados" item-value="id"
                item-text="desc_grado" @change="changeGrado()" autocomplete="off" :rules="[rul.selectReq]">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" sm="6" class="py-0">
              <v-autocomplete label="Sección" v-model="editedItem.id_seccion" :items="lista_secciones" item-value="id"
                item-text="nombre_seccion" @change="changeSeccion()" autocomplete="off" :rules="[rul.selectReq]">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-select label="Estudiante" v-model="editedItem.id_estudiante" :items="lista_estudiantes" item-value="id"
                item-text="nombre_estudiante" :rules="[rul.selectReq]">
              </v-select>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-text-field label="Observacion" type="text" v-model="editedItem.observacion" :rules="[rul.max100]">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-menu v-model="menu_fecha_inicio" :close-on-content-click="true" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="fechaInicioFormatted" label="Fecha de Inicio" readonly v-on="on"
                    :rules="[rul.required]"></v-text-field>
                </template>

                <v-date-picker v-model="editedItem.fecha_inicio" no-title @input="menu_fecha_inicio = false">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-menu v-model="menu_fecha_fin" :close-on-content-click="true" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="fechaFinFormatted" label="Fecha de Fin" readonly v-on="on"
                    :rules="[rul.required]"></v-text-field>
                </template>

                <v-date-picker v-model="editedItem.fecha_fin" no-title @input="menu_fecha_fin = false">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-select label="Banco" v-model="editedItem.id_banco" :items="lista_bancos" item-value="id_banco"
                item-text="nombre_banco" :rules="[rul.selectReq]">
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-text-field label="N de Cuenta" type="text" v-model="editedItem.numero_cuenta"
                :rules="[rul.required, rul.min4, rul.max100]">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-select label="Tipo cuenta" v-model="editedItem.tipo_cuenta" :items="lista_tiempo_cuentas" item-value="id"
                item-text="text" :rules="[rul.selectReq]">
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-select label="Moneda" v-model="editedItem.id_moneda" :items="lista_monedas" item-value="id_moneda"
                item-text="nombre_moneda" :rules="[rul.selectReq]">
              </v-select>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-checkbox v-model="editedItem.autoriza"
                :label="'Al marcar esta casilla autorizo a mi banco a realizar pagos automáticos de las deudas de mi hijo en el colegio mediante débito automático de mi cuenta bancaria. Entiendo que puedo cancelar esta autorización en cualquier momento poniendome en contacto con mi banco y dando por culminado dicho registro en el estado del acuerdo'"
                :rules="[rul.required]">
              </v-checkbox>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp v-if="isNew" :disabled="btnIsSaving" icon-but="fas fa-save" normal-button
            @click="saveItem(editedItem ? editedItem.id_pago_automatico : 0)"
            :text-button="isNew ? 'Guardar' : 'Guardar Cambios'" />

          <ButtonComp class="mx-2" @click="showDialog = false" text-button="Cancelar" class-color="red" normalButton />
        </template>
      </ComunDialogComp>

    </v-form>
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import { DebitoautomaticoHeaders } from '../../../../helpers/headersTable';

export default {
  components: {
    ComundataTablecomp,
    ButtonComp,
    ComunDialogComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    DebitoautomaticoHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    filtro: {
      id_anio: null
    },
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    menu_fecha_inicio: false,
    menu_fecha_fin: false,
    listItems: [],
    lista_filtro_anios: [],
    lista_niveles: [],
    lista_grados: [],
    lista_secciones: [],
    lista_estudiantes: [],
    lista_bancos: [],
    lista_monedas: [],
    lista_tiempo_cuentas: [{ id: "CUENTA AHORROS", text: "CUENTA AHORROS" }, { id: "CUENTA CORRIENTE", text: "CUENTA CORRIENTE" }],
    isNew: true,
    editedItem: {},
  }),

  computed: {
    formTitle() {
      return this.isNew ? "Registro de Deuda" : "Editar Registro de Deuda";
    },
    fechaInicioFormatted() {
      return this.formatDate(this.editedItem.fecha_inicio);
    },
    fechaFinFormatted() {
      return this.formatDate(this.editedItem.fecha_fin);
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaAniosFiltro();
    this.getListaDebitoAutomaticos();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async limpiarForm() {
      this.editedItem = {};
      this.$refs.formDatos.resetValidation();
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.btnIsSaving = false;
      this.isNew = true;
      await this.getListaNiveles();
      await this.getListaBancos();
      await this.getListaMonedas();
      this.showDialog = true;
      this.limpiarForm();
    },

    async editItem(item) {
      console.log(item);
      this.editedItem = item;
      this.btnIsSaving = false;
      this.isNew = false;
      await this.getListaNiveles();
      await this.getListaGrados();
      await this.getListaSecciones();
      await this.getListaEstudiantes();
      await this.getListaBancos();
      await this.getListaMonedas();
      await this.getDebitoAutomaticoById(item.id_pago_automatico);
      this.showDialog = true;
    },

    async changeNivel() {
      await this.getListaGrados();
    },

    async changeGrado() {
      await this.getListaSecciones();
    },

    async changeSeccion() {
      await this.getListaEstudiantes();
    },

    cancelConfirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    async changeFiltroAnio() {
      await this.getListaDebitoAutomaticos();
    },

    /// FILTROS
    getListaAniosFiltro() {
      axios
        .get("/administrativo/anoLectivo/estado/" + this.dataSession.id_colegio)
        .then((response) => {
          this.lista_filtro_anios = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaNiveles() {
      this.lista_niveles = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.dataSession.id_ano_lectivo,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGrados() {
      this.lista_grados = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: this.editedItem.id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaSecciones() {
      this.lista_secciones = [];
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.dataSession.id_ano_lectivo,
        id_nivel: this.editedItem.id_nivel,
        id_grado: this.editedItem.id_grado
      };
      axios
        .post("/tesoreria/common/seccion", params)
        .then((response) => {
          this.lista_secciones = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaEstudiantes() {
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.dataSession.id_ano_lectivo,
        id_seccion: this.editedItem.id_seccion
      };
      axios
        .post("/tesoreria/common/estudiante", params)
        .then((response) => {
          this.lista_estudiantes = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaBancos() {
      axios
        .get("/tesoreria/common/banco")
        .then((response) => {
          this.lista_bancos = response.data;
          console.log(this.lista_bancos);
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
          //console.log(e);
        });
    },

    getListaMonedas() {
      axios
        .get("/tesoreria/common/moneda")
        .then((response) => {
          this.lista_monedas = response.data;
          console.log(this.lista_monedas);
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getDebitoAutomaticoById(id) {
      axios
        .get("/tesoreria/pago/debito_automatico/" + id)
        .then((response) => {
          this.editedItem = response.data;
          this.editedItem.fecha_inicio = this.editedItem.fecha_inicio.slice(0, 10);
          this.editedItem.fecha_fin = this.editedItem.fecha_fin.slice(0, 10);
          console.log('editedItem', this.editedItem);
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
        });
    },

    async getListaDebitoAutomaticos() {
      this.selectedItems = [];
      this.loading = true;
      this.filtro.id_colegio = this.dataSession.id_colegio;
      await axios
        .post("/tesoreria/pago/debito_automatico/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },

    async saveItem() {
      if (this.$refs.formDatos.validate()) {
        this.btnIsSaving = true;
        try {
          let response;
          const params = Object.assign({}, this.editedItem);
          params["user_id"] = this.dataSession.id;
          params["colegio_id"] = this.dataSession.id_colegio;
          params["id_anio"] = this.dataSession.id_ano_lectivo;
          params["autoriza"] = this.editedItem.autoriza ? 1 : 0;

          response = await axios.post("/tesoreria/pago/debito_automatico", params);
          this.showDialog = false;
          this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });
          this.limpiarForm();
          this.getListaDebitoAutomaticos();
        }
        catch (error) {
          this.btnIsSaving = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },


  },
};
</script>